import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BannerLayer from "../components/BannerLayer";

const BannerListPage = () => {
    return (
        <MasterLayout>
            <BannerLayer />
        </MasterLayout>
    );
};

export default BannerListPage;
